class PwdEstimatedDelivery extends HTMLElement {
  constructor() {
    super();
    this.day = this.querySelector('.js-pwd-estimated-delivery-day');
    this.timer = this.querySelector('.js-pwd-estimated-delivery-timer');
    this.orderDate = this.querySelector('.js-pwd-estimated-delivery-order-day');
    this.arrivalDate = this.querySelector('.js-pwd-estimated-delivery-arrival-day');

    // Update the countdown every second and dates
    setInterval(() => {
      let midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      this.updateCountdown(midnight);
      this.updateDates(midnight);
    }, 1000);
  }

  updateCountdown(midnight) {
    // Set local instance
    let localMidnight = new Date(midnight);

    // Get current time
    const now = new Date();
    
    // Calculate time until midnight
    let timeUntilMidnight = localMidnight - now;
    if (timeUntilMidnight < 0) {
      localMidnight.setDate(localMidnight.getDate() + 1);
      timeUntilMidnight = localMidnight - now;
    }

    // Convert milliseconds to hours, minutes, and seconds
    const hours = Math.floor(timeUntilMidnight / (1000 * 60 * 60)).toString().padStart(2, '0');
    const minutes = Math.floor((timeUntilMidnight % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
    const seconds = Math.floor((timeUntilMidnight % (1000 * 60)) / 1000).toString().padStart(2, '0');

    // Display the countdown
    this.timer.innerHTML = `${hours}h:${minutes}m:${seconds}s`.padStart(11, '0');
  }

  updateDates(midnight) {
    // Set local instance
    let localMidnight = new Date(midnight);

    // Get current date
    const currentDate = new Date();
    const arrivalDate = new Date();

    // Define the number of days to add
    const daysToAdd = 2; // You can change this to any number of days you want to add

    // Add days to the current date
    arrivalDate.setDate(currentDate.getDate() + daysToAdd);

    // Calculate time until midnight
    let timeUntilMidnight = localMidnight - currentDate;
    if (timeUntilMidnight < 0) {
      arrivalDate.setDate(arrivalDate.getDate() + 1);
    }

    // Define an array of month names
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    // Get the day of the week and month in the desired format for both dates
    const currentDayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][currentDate.getDay()];
    const currentMonth = monthNames[currentDate.getMonth()];
    const currentDayOfMonth = currentDate.getDate();

    const modifiedDayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][arrivalDate.getDay()];
    const modifiedDayOfWeekFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][arrivalDate.getDay()];
    const modifiedMonth = monthNames[arrivalDate.getMonth()];
    const modifiedDayOfMonth = arrivalDate.getDate();

    // Concatenate the parts to get the final formatted dates
    this.orderDate.innerHTML = `${currentDayOfWeek} ${currentMonth} ${currentDayOfMonth}`;
    this.arrivalDate.innerHTML = `${modifiedDayOfWeek} ${modifiedMonth} ${modifiedDayOfMonth}`;
    this.day.innerHTML = `${modifiedDayOfWeekFull}.`;
  }
}
customElements.define('pwd-estimated-delivery', PwdEstimatedDelivery);